import { ComboBoxMultiTrigger } from "./ComboBoxMultiTrigger";
import { ComboBoxSingleTrigger } from "./ComboBoxSingleTrigger";
import { useComboBoxContext } from "./context";
import type { IComboBoxTriggerProps } from "./types";

export const ComboBoxTrigger = (props: IComboBoxTriggerProps = {}) => {
  const { multiple } = useComboBoxContext();

  if (multiple) {
    return <ComboBoxMultiTrigger {...props} />;
  }

  return <ComboBoxSingleTrigger {...props} />;
};
